export const pageload = {
  unmounted: { opacity: 0 },
  mounted: { opacity: 1 },
};
